"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialActionWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SpecialActionWrapper = styled_components_1.default.div `
  position: relative;
`;
//# sourceMappingURL=special-action-wrapper.js.map